/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type VipAccountManagerLink_viewer = {|
  +userRelationships?: ?$ReadOnlyArray<?{|
    +userDataB: ?$ReadOnlyArray<?{|
      +displayName?: ?string;
      +phoneNumber?: ?string;
      +email?: ?string;
    |}>;
  |}>;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "fetchRep",
      "type": "Boolean!",
      "defaultValue": false
    },
    {
      "kind": "RootArgument",
      "name": "userIds",
      "type": "[String]!"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "VipAccountManagerLink_viewer",
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchRep",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "relationshipType",
              "value": "VIP",
              "type": "relationshipType!"
            },
            {
              "kind": "Variable",
              "name": "userIds",
              "variableName": "userIds",
              "type": "[String]!"
            }
          ],
          "concreteType": "UserRelationship",
          "name": "userRelationships",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": null,
              "name": "userDataB",
              "plural": true,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "type": "VipRepData",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "displayName",
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "formatType",
                          "value": "INTERNATIONAL",
                          "type": "formatPhoneNumberTypes"
                        }
                      ],
                      "name": "phoneNumber",
                      "storageKey": "phoneNumber{\"formatType\":\"INTERNATIONAL\"}"
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "email",
                      "storageKey": null
                    }
                  ]
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
